import React from 'react';
import { Button } from 'antd';
import { SvgAlert } from '../SvgIcons';
import s from './s.module.less';

interface Props {
    name: string;
    detail: string;
    btnText?: string;
    onAction?: () => void;
}

const ActionNeededCard = ({ name, detail, btnText, onAction }: Props) => (
    <div className={s.actionBlock}>
        <div className={s.actionBlockIcon}><SvgAlert /></div>
        <div className={s.actionBlockBody}>
            <div className={s.actionBlockName}>{name}</div>
            <div className={s.actionBlockDetail}>{detail}</div>
        </div>
        {btnText && <Button type="primary" className={s.actionBlockBtn} onClick={onAction}>{btnText}</Button>}
    </div>
);

export default ActionNeededCard;
